import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "sonner";

import Nav from "@/components/Nav";
import Marketplace from "@/pages/Marketplace";
import ProductDetail from "@/pages/ProductDetail";
import Login from "@/pages/Login";
import CreatorStudio from "@/pages/CreatorStudio";
import CreatorProfile from "@/pages/CreatorProfile";
import Leaderboard from "@/pages/Leaderboard";
import MyLibrary from "@/pages/MyLibrary";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback fragment
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Nav />
      <main className="min-h-[calc(100vh-4rem)]">
        <Routes>
          <Route path="/" element={<Marketplace />} />
          <Route path="/p/:id" element={<ProductDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/studio" element={<CreatorStudio />} />
          <Route path="/creator/:id" element={<CreatorProfile />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/library" element={<MyLibrary />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
      </main>
      <footer className="border-t border-white/10 mt-24 py-10">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 flex flex-wrap items-center justify-between gap-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
            © DIGITAL/DROPS · Shared store for limited edition digital work
          </div>
          <div className="flex items-center gap-4">
            <a
              href="/api/feed.xml"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 hover:text-[#CCFF00]"
            >
              RSS
            </a>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40">
              Payments · Stripe (test) · Storage · Emergent Object Store
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
